/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'components/chevron-down-alt2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" _fill="#242424" d="M12 7l-4 4-4-4 1-1 3 3 3-3 1 1z"/>'
  }
})
